import React from "react";

export default function CosfiMiniGauge({ value = 0, label }) {
  const min = -1;
  const max = 1;

  // -1 → 180°, 0 → 270°, 1 → 360°
  const startAngle = 180;
  const midAngle = 270;
  const endAngle = 360;

  // Değeri -1..1 aralığına clamp et
  function clamp(v) {
    if (v == null || isNaN(v)) return 0;
    return Math.max(min, Math.min(max, v));
  }

  function valueToAngle(vRaw) {
    const v = clamp(vRaw);

    if (v <= 0) {
      // -1 .. 0  →  180 .. 270
      const ratio = (v - min) / (0 - min); // 0..1
      return startAngle + ratio * (midAngle - startAngle);
    } else {
      // 0 .. 1   →  270 .. 360
      const ratio = (v - 0) / (max - 0); // 0..1
      return midAngle + ratio * (endAngle - midAngle);
    }
  }

  function polar(cx, cy, r, angle) {
    const rad = (angle * Math.PI) / 180;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  }

  const gaugeColor = "#0ea5e9";

  const angle = valueToAngle(value);
  const centerX = 60;
  const centerY = 90;

  // ARC için uçlar
  const arcStart = polar(centerX, centerY, 50, startAngle);
  const arcEnd = polar(centerX, centerY, 50, endAngle);

  // İbre ucu
  const needleEnd = polar(centerX, centerY, 45, angle);

  return (
    <div className="flex flex-col items-center bg-white p-4 rounded-xl border border-slate-200 shadow-sm w-full">
      <svg width="120" height="110" viewBox="0 0 120 110">
        {/* TEK RENK ARC */}
        <path
          d={`M ${arcStart.x} ${arcStart.y} A 50 50 0 0 1 ${arcEnd.x} ${arcEnd.y}`}
          stroke={gaugeColor}
          strokeWidth="12"
          strokeLinecap="round"
          fill="none"
        />

        {/* TICKS (-1, -0.5, 0, 0.5, 1) */}
        {[-1, -0.5, 0, 0.5, 1].map((v, i) => {
          const a = valueToAngle(v);
          const p1 = polar(centerX, centerY, 44, a);
          const p2 = polar(centerX, centerY, 50, a);
          return (
            <line
              key={i}
              x1={p1.x}
              y1={p1.y}
              x2={p2.x}
              y2={p2.y}
              stroke="#6b7280"
              strokeWidth="2"
            />
          );
        })}

        {/* NEEDLE – ROTATE YOK, DİREKT KOORDİNAT */}
        <line
          x1={centerX}
          y1={centerY}
          x2={needleEnd.x}
          y2={needleEnd.y}
          stroke="black"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <circle cx={centerX} cy={centerY} r="4" fill="black" />
      </svg>

      <div className="text-lg font-semibold text-slate-700">
        {value != null ? clamp(value).toFixed(3) : "-"}
      </div>

      <div className="text-xs text-slate-500">{label}</div>
    </div>
  );
}
